import { useQuery } from '@tanstack/react-query';
import {
   getSingleEntryFromClient,
   GetSingleEntryResponse,
} from '~/pages/api/signoffs/getSingleEntry.api';

export type { GetSingleEntryResponse };

const KEY = 'single_entry';

export function useSingleEntry(entryid: number) {
   const queryFunction = async () => {
      return await getSingleEntryFromClient(entryid);
   };

   return useQuery({
      queryFn: queryFunction,
      queryKey: [KEY, entryid],
   });
}
